import React, { useEffect, useState } from 'react';
import { AuditDTO } from '../../models/AuditLog/AuditDTO';
import { useNavigate } from 'react-router-dom';
import { SettingsService } from "../../services/SettingsService";
import { SortingRule } from 'react-table';
import { Utilities } from '../../helpers/Utilities';
import { FormattedMessage } from 'react-intl';
import { Tooltip } from '@mui/material';
import RoutesObject from '../../helpers/Routes';
import { FcViewDetails } from 'react-icons/fc';
import Toast from '../../helpers/Toast';
import TableComponent from '../TableComponent';

interface SettingAuditLogProps {
    settingId: number | null;
}

function SettingAuditLog({ settingId }: SettingAuditLogProps) {
    const pageSizes: number[] = [5, 10, 15, 30];
    const [data, setData] = useState<AuditDTO[]>([]);
    const [loading, setLoading] = useState(false);
    const [pageCount, setPageCount] = useState(1);
    const navigate = useNavigate();
    const service = new SettingsService();

    const [currentPage, setCurrentPage] = useState<number>();
    const [currentPageSize, setCurrentPageSize] = useState<number>();
    const [currentSorting, setCurrentSorting] = useState<SortingRule<object>[] | null>(null);

    const [initialSortBy] = useState<SortingRule<object>[]>(Utilities.LoadSortParametersFromURLQuery("sortField", "sortOrder"));
    const [page] = useState<number>(Utilities.LoadPageFromURLQuery("page"));
    const [pageSize] = useState<number>(Utilities.LoadPageSizeFromURLQuery(pageSizes, 10));
        
    const [goToPage, setGoToPage] = useState<number>();

    const columns = React.useMemo(
        () => [
            {
                Header: <FormattedMessage id="Screens.Setting.AuditLog.Table.Date" />,
                accessor: "dateString",
                width: 70,
            },
            {
                Header: "",
                accessor: " ",
                width: 30,
                Cell: (props: any) => {
                    return (
                        <Tooltip
                            title="Ver Detalhes"
                            aria-label="Ver Detalhes"
                            enterNextDelay={500}
                            enterDelay={500}>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer"
                                }}
                                onClick={() => { navigate(`${RoutesObject.auditLogs.details}/${props.cell.row.original.id}`) }}
                            >
                                <FcViewDetails className="icons" />
                            </div>
                        </Tooltip>
                    );
                },
            },
        ],
        [],
    );

    const fetchData = async (page: number, pageSize: number, sortBy: SortingRule<object>[] | null) => {
        var searchUrl: string = Utilities.CreateSearchURL([
            `page=${page}`,
            `pageSize=${pageSize}`,
        ]);
        if (sortBy != null && sortBy.length > 0) {
            searchUrl += `${Utilities.AddParamToQueryIfValue("sortField", "string", sortBy[0].id)}${Utilities.AddParamToQueryIfValue(
                "sortOrder", "string", sortBy[0].desc === true ? "DESC" : "ASC",
            )}`;
        }
            
        setLoading(true);
        var response = await service.GetAuditLogBySettingId(
            settingId == null ? null : settingId?.toString(),
            Utilities.MountSortParameters(sortBy),
            page,
            pageSize,
        );

        if (response.success !== true) {
            setCurrentPage(1);
            setGoToPage(1);
            setData([]);
            setPageCount(0);
            setLoading(false);
            setCurrentSorting(null);
            Toast.Show("error", response.message);
            return;
        }
        if (response.items.length === 0) {
            setCurrentPage(1);
            setGoToPage(1);
            Toast.Show("success", "Não existe nenhum histórico com esses dados");
        }
        setData(response.items);
        setPageCount(response.totalPages);
        setLoading(false);
        setCurrentPageSize(pageSize);
        setCurrentPage(page);
        setCurrentSorting(sortBy);
        setGoToPage(0)
    
        if (response.totalPages > 0 && page > response.totalPages) {
            setGoToPage(1);
        }

    };

    useEffect(() => {
        if (loading) {
            fetchData(currentPage ?? 1, currentPageSize ?? 10, currentSorting);
        }
    }, []);

        
    return (
        <div className="pageComponent" style={{ width: "100%" }}>
            <TableComponent
                goToPage={goToPage}
                loading={loading}
                pageCount={pageCount}
                columns={columns}
                manualPagination={true}
                fetchData={fetchData}
                pageSizes={pageSizes}
                initialPage={page}
                initialPageSize={pageSize}
                initialSortBy={initialSortBy}
                data={data}
            />
        </div>
    )
}

export default SettingAuditLog;